import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {bankcardverifys,bankcardApprove,bankcardDisapprove} = api

/**
 * 查找列表
 */
export async function findBankcardverifys(params) {
    return request({url:bankcardverifys, method: 'get', data: params,})
}
/**
 * 审核通过
 */
export async function approveBankcard(params) {
    return request({url:bankcardApprove, method: 'post', data: params,})
}
/**
 * 审核拒绝
 */
export async function disapproveBankcard(params) {
    return request({url:bankcardDisapprove, method: 'post', data: params,})
}


// WEBPACK FOOTER //
// ./src/services/bankcardVerify.js